export default __webpack_public_path__ + "static/media/7h.824b0123.png";